// /* eslint-disable react-hooks/exhaustive-deps */
// import React, { useState, useEffect, ChangeEvent, useRef, useCallback } from "react";
// import { Button } from "../../../../Components/ui/button";
// import Default_WhatsApp_background from "../../../../Assets/Default_WhatsApp_background.jpeg";
// import { useToast } from "../../../../Components/ui/use-toast";
// import { Toaster } from "../../../../Components/ui/toaster";
// import { Combobox } from "../../../../Components/ui/combobox";

// import {
//   Select,
//   SelectContent,
//   SelectItem,
//   SelectTrigger,
//   SelectValue,
// } from "../../../../Components/ui/select";
// import {
//   Dialog,
//   DialogClose,
//   DialogContent,
//   DialogDescription,
//   DialogFooter,
//   DialogHeader,
//   DialogTitle,
//   DialogTrigger,
// } from "../../../../Components/ui/dialog";
// import { Input } from "../../../../Components/ui/input";
// import CloseIcon from "@mui/icons-material/Close";
// import { Label } from "../../../../Components/ui/label";
// import { Textarea } from "../../../../Components/ui/textarea";
// import { FaTrash, FaTimes, FaFilePdf, FaFileWord } from "react-icons/fa";
// import { FaPlus, FaCaretDown } from "react-icons/fa";
// import CancelIcon from "@mui/icons-material/Cancel";
// import { Add as AddIcon } from "@mui/icons-material";
// import EmojiPicker from "emoji-picker-react"


// import {
//   Container,
//   Box,
//   Typography,
//   TextField,
//   IconButton,
//   CircularProgress,
// } from "@mui/material";
// import {
//   ChevronDownIcon,
//   PlusIcon,
//   InfoCircledIcon,
//   FontBoldIcon,
//   FontItalicIcon,
//   CodeIcon,
// } from "@radix-ui/react-icons";
// import { CheckIcon } from "@radix-ui/react-icons";
// import { Card } from "../../../../Components/ui/card";
// import { Smile, Strikethrough } from "lucide-react";
// import { Document, Page } from "react-pdf";
// import { useCampaignContext } from "../CampaignContext";
// import axios, { AxiosResponse } from "axios";
// import { useSelector, useDispatch } from "react-redux";
// import { RootState } from "@/src/State/store";
// import { useCampaignValidators } from "../hooks/useCampaignValidators";


// interface BoxItem {
//   action: string;
// }

// interface Language {
//   language_id: number;
//   language_name: string;
//   language_code: string;
// }

// interface Country {
//   country_id: number;
//   country_code: number;
//   country_name: string;
//   country_shortname: string;
// }

// interface GetButtonTypeList {
//   button_id: number;
//   button_type: string;
// }

// interface Template {
//   template_id: number;
//   template_name: string;
// }

// interface Content {
//   content_id: number;
//   content_name: string;
// }

// interface RowData {
//   buttonType: string;
//   buttonText: string;
//   buttonTypeDropdown: string;
//   websiteUrl: string;
//   countryCode: string;
//   callPhoneNumber: string;
//   copyOfferCode: string;
//   // quickReplyResponse?: string;
//   // optOut?: boolean;
// }

// interface Channel {
//   channel_id: number;
//   channel_name: string;
// }

// const textAreaIcon = () => {
//   return (
//     <div className="relative w-8 h-8 flex justify-center items-center">
//       <div
//         className="absolute rounded w-[3px] h-8 transform rotate-45"
//         style={{ borderLeft: "3px solid #64748B" }}
//       />
//       <div
//         className="absolute w-[3px] h-4 rounded transform rotate-45 translate-x-2 translate-y-2"
//         style={{ borderLeft: "3px solid #64748B" }}
//       />
//     </div>
//   );
// };

// interface CreateContentWhatsapp {
//   onClose: () => void;
// }

// const CreateContentWhatsapp: React.FC<CreateContentWhatsapp> = ({
//   onClose,
// }) => {
//   const [languageList, setLanguageList] = useState<Language[]>([]);
//   const [countryList, setCountryList] = useState<Country[]>([]);

//   const [Content, setContent] = useState("");
//   const [ContentList, setContentList] = useState<Content[]>([]);
//   const [buttonType, setButtonType] = useState("");
//   const [buttonList, setButtonList] = useState<GetButtonTypeList[]>([]);
//   const [templateList, setTemplateList] = useState<Template[]>([]);
//   const [templateName, setTemplateName] = useState("");
//   const [isAlertOpen, setIsAlertOpen] = useState(false);
//   const [templateName1, setTemplateName1] = useState("");
//   const [file, setFile] = useState<File | null>(null);
//   const [buttonT, setButtonT] = useState<number>(0);
//   const [senderName, setSenderName] = useState("");
//   const [templatePreview, setTemplatePreview] = useState<string>("");
//   const [buttonData, setButtonData] = useState<{
//     buttonText: string;
//     websiteUrl: string;
//   }>({
//     buttonText: "",
//     websiteUrl: "",
//   });
//   const [showDropdown, setShowDropdown] = useState<boolean>(false);
//   const [selectedAction, setSelectedAction] = useState<string | null>(null);
//   const [buttonTypeDropdown, setButtonTypeDropdown] =
//     useState<string>("static");
//   const [buttonText, setButtonText] = useState<string>("");
//   const [websiteUrl, setWebsiteUrl] = useState<string>("");
//   const [boxes, setBoxes] = useState<BoxItem[]>([]);
//   const [channelList, setChannelList] = useState<Channel[]>([]);
//   const [channel, setChannel] = useState("");
//   const [templateType, setTemplateType] = useState("");
//   const [PlatformNameError, setPlatformNameError] = useState<string | null>(
//     null
//   );
//   const [templateError, setTemplateError] = useState<string | null>(null);
//   const [LanguageError, setLanguageError] = useState<string | null>(null);
//   const [channelError, setChannelError] = useState<string | null>(null);
//   const [BodyError, setBodyError] = useState<string | null>(null);
//   const fileInputRef = useRef<HTMLInputElement>(null);
//   const [showFileInput, setShowFileInput] = useState(true);
//   const [warning, setWarning] = useState("");
//   const [selectedButtonIds, setSelectedButtonIds] = useState<string[]>([]);
//   const [websiteUrls, setWebsiteUrls] = useState<string[]>([]);
//   const maxLength = 60;
//   const [headerHandle, setHeaderHandle] = useState("");
//   const [inputStr, setInputStr] = useState("");
//   const [showPicker, setShowPicker] = useState(false);
//   const previewRef = useRef<HTMLDivElement>(null);
//   const [isFixed, setIsFixed] = useState(true);

//   //Present
//   const [languageOptions, setLanguageOptions] = useState<
//     { label: string; value: string }[]
//   >([]);
//   const [allCountryCodes, setAllCountryCodes] = useState<
//     { label: string; value: string }[]
//   >([]);

//   const {
//     setWhatsappContent,
//     campaignName,
//     setLanguage,
//     language,
//     setBodyText,
//     bodyText,
//     setFooterText,
//     FooterText,
//     headerType,
//     setHeaderType,
//     textInput,
//     setTextInput,
//     setSelectedFile,
//     selectedFile,
//     setPreviewImage,
//     previewImage,
//     rows,
//     setRows,
//     setIsWhatsappContentSubmitAttempted,
//     isWhatsappContentSubmitAttempted,
//     languageError,
//     phoneNumberError,
//     whatsappBodyError,
//     resetWhatsappContent,
//     setUploadError,
//     uploadError,
//     setFileName,
//     fileName,
//     setFileLength,
//     fileLength,
//     setFileType,
//     fileType,
//     setMediaBase64,
//     mediaBase64,
//     setSelectedOption,
//     selectedOption,
//     headerTextError,
//     whatsappFooterError,
//     // Button validation error states from context
//     buttonValidationErrors,
//     getButtonError,
//     setButtonError,
//     clearButtonErrors,
//     buttonsError,
//     isViewMode,
//     setWhatsappBodyError,
//     setHeaderTextError,
//     setWhatsappFooterError,
//     isUpdateMode
//   } = useCampaignContext();

//   const apiUrlAdvAcc = useSelector(
//     (state: RootState) => state.authentication.apiURL
//   );
//   const workspaceId = useSelector((state: RootState) => state.authentication.workspace_id);

//   const {
//     validateLanguage,
//     validatePhoneNumber,
//     validateWhatsappBody,
//     validateHeaderText,
//     validateWhatsappFooter,
//     validateButtonText,
//     validateWebsiteUrl,
//     validateCallPhoneNumber,
//     validateCountryCode,
//     validateOfferCode,
//     validateButtonType,
//     validateButtonsArray
//   } = useCampaignValidators();

//   const toast = useToast();

//   const dispatch = useDispatch();

//   useEffect(() => {
//     GetAllCountryCodes();
//     GetLanguages();
//   }, []);

//   const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
//     const file = event.target.files?.[0];

//     if (file) {
//       debugger;

//       const fileLimit = Number(process.env.REACT_APP_FILE_UPLOAD_LIMIT);
//       const maxSizeInBytes = fileLimit * 1024 * 1024;

//       if (file.size > maxSizeInBytes) {
//         setUploadError(`Only files up to ${fileLimit}MB are allowed.`);
//         event.target.value = "";
//         return;
//       }

//       const testreader = new FileReader();
//       testreader.onload = () => {
//         const base64String = testreader.result as string;
//       };
//       testreader.readAsDataURL(file);

//       const ext = file.name.split(".").pop()?.toLowerCase() || "";

//       const allowedImageExts = ["jpeg", "jpg", "png"];
//       const allowedVideoExts = ["mp4"];
//       const allowedDocExts = ["pdf"];

//       const isImage =
//         file.type.startsWith("image/") && allowedImageExts.includes(ext);
//       const isVideo =
//         file.type === "video/mp4" && allowedVideoExts.includes(ext);
//       const isPdf =
//         file.type === "application/pdf" && allowedDocExts.includes(ext);

//       if (!isImage && !isVideo && !isPdf) {
//         setUploadError(
//           "Only JPG, JPEG, PNG images, MP4 videos, or PDF documents are allowed."
//         );
//         event.target.value = "";
//         return;
//       }

//       setUploadError(null);

//       setSelectedFile(file);
//       setFileName(file.name);
//       setFileLength(file.size.toString());
//       setFileType(file.type);

//       if (isImage) {
//         const reader = new FileReader();
//         reader.onload = (e) => {
//           setPreviewImage(e.target?.result as string);
//         };
//         reader.readAsDataURL(file);
//       }

//       debugger;

//       const reader = new FileReader();
//       reader.onload = () => {
//         const base64String = reader.result as string;
//         setMediaBase64(base64String);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const onEmojiClick = (emojiObject: any) => {
//     setBodyText((prev) => prev + emojiObject.emoji);
//     setShowPicker(false);
//   };

//   const insertFormattingTags = (startTag: string, endTag: string) => {
//     const textarea = document.querySelector(
//       'textarea[name="bodyText"]'
//     ) as HTMLTextAreaElement;
//     if (!textarea) return;

//     const start = textarea.selectionStart;
//     const end = textarea.selectionEnd;
//     const selectedText = textarea.value.substring(start, end);
//     const replacement = startTag + selectedText + endTag;

//     const newValue =
//       textarea.value.substring(0, start) +
//       replacement +
//       textarea.value.substring(end);
//     setBodyText(newValue);

//     setTimeout(() => {
//       textarea.focus();
//       textarea.setSelectionRange(
//         start + startTag.length,
//         start + startTag.length + selectedText.length
//       );
//     }, 0);
//   };

//   const addButtonRow = () => {
//     if (rows.length < 3) {
//       const newRow: RowData = {
//         buttonType: "",
//         buttonText: "",
//         buttonTypeDropdown: "static",
//         websiteUrl: "",
//         countryCode: "",
//         callPhoneNumber: "",
//         copyOfferCode: "",
//         // quickReplyResponse: "",
//         // optOut: false
//       };
//       setRows([...rows, newRow]);
//     }
//   };

//   const removeButtonRow = (index: number) => {
//     const updatedRows = rows.filter((_, i) => i !== index);
//     setRows(updatedRows);
//     clearButtonErrors(index);
//   };

//   const updateButtonRow = (
//     index: number,
//     field: keyof RowData,
//     value: string
//   ) => {
//     const updatedRows = rows.map((row, i) => {
//       if (i === index) {
//         const updatedRow = { ...row, [field]: value };

//         if (field === "buttonType") {
//           switch (value) {
//             case "COPY_CODE":
//               updatedRow.buttonText = "Copy";
//               break;
//             case "URL":
//             case "PHONE_NUMBER":
//               if (row.buttonType === "COPY_CODE") {
//                 updatedRow.buttonText = "";
//               }
//               break;
//             default:
//               break;
//           }
//         }

//         return updatedRow;
//       }
//       return row;
//     });
//     setRows(updatedRows);
//   };

//   const renderFormattedText = (text: string) => {
//     return text
//       .replace(/\*([^*]+)\*/g, "<strong>$1</strong>")
//       .replace(/_([^_]+)_/g, "<em>$1</em>")
//       .replace(/~([^~]+)~/g, "<s>$1</s>")
//       .replace(
//         /`([^`]+)`/g,
//         '<code style="background: #f1f1f1; padding: 2px 4px; border-radius: 3px;">$1</code>'
//       )
//       .replace(
//         /\{\{(\d+)\}\}/g,
//         '<span style="background: #e3f2fd; padding: 2px 4px; border-radius: 3px; color: #1976d2;">{{$1}}</span>'
//       );
//   };

//   const noContentSelected =
//     !textInput.trim() &&
//     !previewImage &&
//     !selectedFile &&
//     !bodyText.trim() &&
//     !FooterText.trim() &&
//     rows.filter((row) => row.buttonText.trim()).length === 0;

//   const handleSubmitWhatsApp = async () => {
//     const [
//       isLanguageValid,
//       isBodyValid,
//       isHeaderTextValid,
//       isFooterTextValid,
//       isButtonsValid
//     ] = await Promise.all([
//       Promise.resolve(validateLanguage(language)),
//       Promise.resolve(validateWhatsappBody(bodyText, language, setWhatsappBodyError)),
//       Promise.resolve(validateHeaderText(textInput, language, setHeaderTextError)),
//       Promise.resolve(validateWhatsappFooter(FooterText, language, setWhatsappFooterError)),
//       Promise.resolve(validateButtonsArray(rows)),
//     ]);

//     const isFormValid =
//       isLanguageValid &&
//       isBodyValid &&
//       isHeaderTextValid &&
//       isFooterTextValid &&
//       isButtonsValid;

//     console.log("Form valid", isFormValid);

//     if (!isFormValid) {
//       toast.toast({
//         title: "Validation Failed",
//         description: "Please correct the highlighted errors before saving.",
//       });
//       return;
//     }

//     // const templateName = `${campaignName.toLocaleLowerCase()}_whatsapp_${workspaceId}`;

//     const templateName = `${campaignName.toLocaleLowerCase().replace(/\s+/g, '')}_whatsapp_${workspaceId}`;

//     const rawComponents: any[] = [];

//     if (selectedOption && selectedOption !== "none") {
//       const headerObj: any = {
//         type: "HEADER",
//         format: headerType?.toUpperCase(),
//       };

//       if (headerType === "text" && textInput) {
//         headerObj.text = textInput;
//       } else if (["image", "video", "document"].includes(headerType)) {
//         headerObj.example = { header_handle: [headerHandle] };
//       }

//       rawComponents.push(headerObj);
//     }

//     rawComponents.push({
//       type: "BODY",
//       text: bodyText,
//     });

//     if (FooterText) {
//       rawComponents.push({
//         type: "FOOTER",
//         text: FooterText,
//       });
//     }

//     const buttons = rows
//       .filter((row) => row.buttonText.trim())
//       .map((row) => {
//         if (row.buttonType === "URL") {
//           return {
//             type: "URL",
//             text: row.buttonText,
//             url: row.websiteUrl,
//           };
//         } else if (row.buttonType === "PHONE_NUMBER") {
//           return {
//             type: "PHONE_NUMBER",
//             text: row.buttonText,
//             phone_number: row.countryCode + row.callPhoneNumber,
//           };
//         } else if (["COPY_CODE"].includes(row.buttonType)) {
//           return {
//             type: "COPY_CODE",
//             example: row.copyOfferCode,
//           };
//         }
//         // else if (row.buttonType === "QUICK_REPLY") {
//         //   return {
//         //     type: "QUICK_REPLY",
//         //     text: row.buttonText,
//         //   };
//         // }
//         return {};
//       });

//     if (buttons.length > 0) {
//       rawComponents.push({
//         type: "BUTTONS",
//         buttons,
//       });
//     }

//     // const qrArray = rows
//     //   .filter((row) => row.buttonType === "QUICK_REPLY" && row.buttonText.trim())
//     //   .map((row) => ({
//     //     label: row.buttonText,
//     //     response: row.quickReplyResponse,
//     //     opt_out: row.optOut ?? false,
//     //   }));

//     const template: any = {
//       name: templateName,
//       language: language,
//       category: "MARKETING",
//       components: JSON.stringify(rawComponents),
//     };

//     debugger

//     const finalWhatsappPayload = {
//       template: {
//         channel_id: 1,
//         channel_type: "Whatsapp",
//         part_count: 1,
//         campaign_name: campaignName,
//         media_config: {
//           file_name: fileName,
//           file_length: fileLength,
//           file_type: fileType,
//           binary_data: mediaBase64,
//         },
//         template_content: template,
//         // ...(qrArray.length > 0 && { QR: qrArray }),
//       }
//     };

//     setWhatsappContent(finalWhatsappPayload);
//     onClose();
//   };

//   //APIs
//   const GetAllCountryCodes = async () => {
//     try {
//       const response = await axios.get(`${apiUrlAdvAcc}/GetAllCountryCodes`);

//       if (
//         response.data?.status === "Success" &&
//         Array.isArray(response.data.country_codes)
//       ) {
//         const options = response.data.country_codes;
//         setAllCountryCodes(options);
//       } else {
//       }
//     } catch (error) {
//     }
//   };

//   const GetLanguages = async () => {
//     try {
//       const response = await axios.get(`${apiUrlAdvAcc}/GetLanguages`);

//       if (
//         response.data?.status === "Success" &&
//         Array.isArray(response.data.languages)
//       ) {
//         setLanguageOptions(response.data.languages);
//       } else {
//       }
//     } catch (error) {
//     }
//   };

//   const useDebounce = (callback: Function, delay: number) => {
//     const timeoutRef = useRef<NodeJS.Timeout | null>(null);

//     return useCallback((...args: any[]) => {
//       if (timeoutRef.current) {
//         clearTimeout(timeoutRef.current);
//       }
//       timeoutRef.current = setTimeout(() => callback(...args), delay);
//     }, [callback, delay]);
//   };

//   useEffect(() => {
//     if (rows.length > 0) {
//       validateButtonsArray(rows);
//     }
//   }, [rows]);

//   useEffect(() => {
//     rows.forEach((_, index) => {
//       clearButtonErrors(index);
//     });

//     const timeoutId = setTimeout(() => {
//       if (rows.length > 0) {
//         validateButtonsArray(rows).catch(error => {
//           console.error("Validation error:", error);
//         });
//       }
//     }, 100);

//     return () => clearTimeout(timeoutId);
//   }, [language]);

//   return (
//     <>
//       <div className="flex flex-col md:flex-row gap-6 mb-6 mt-4">
//         {/* Left Column - Form */}
//         <div className="space-y-6 w-full md:w-3/5">
//           {/* Content Card */}
//           <Card className="border p-4 rounded-lg text-left">
//             <h2 className="text-base font-semibold mb-2">Content</h2>

//             <div className="flex-shrink-0">
//               <Label htmlFor="language">Language</Label>
//               <Combobox
//                 value={language}
//                 onChange={(val) => {
//                   setLanguage(val);
//                   validateLanguage(val);
//                   validateWhatsappBody(bodyText, val, setWhatsappBodyError);
//                   validateWhatsappFooter(FooterText, val, setWhatsappFooterError);
//                   validateHeaderText(textInput, val, setHeaderTextError);
//                   validateButtonsArray(rows);
//                 }}
//                 options={languageOptions ?? []}
//                 placeholder="Select Language"
//                 disabled={isViewMode}
//               />

//               {isWhatsappContentSubmitAttempted && languageError && (
//                 <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
//                   {languageError}
//                 </p>
//               )}
//             </div>

//             <div className="space-y-4 mt-4">
//               {/* Header Type Selection */}
//               <div>
//                 <Label>Header Type</Label>
//                 <div
//                   style={{
//                     background: "#F0F4F8",
//                     color: "#64748B",
//                     padding: "2px 10px",
//                     borderRadius: "9999px",
//                     display: "inline-flex",
//                     alignItems: "center",
//                     height: "20px",
//                     marginLeft: "8px",
//                     fontSize: "14px",
//                     fontWeight: 600,
//                   }}
//                 >
//                   Optional
//                 </div>
//                 <Select
//                   value={headerType}
//                   onValueChange={(value) => {
//                     setHeaderType(value);
//                     setSelectedOption(value);
//                     if (value !== "text") {
//                       setTextInput("");
//                     }
//                     if (!["image", "video", "document"].includes(value)) {
//                       setSelectedFile(null);
//                       setPreviewImage(null);
//                     }
//                   }}
//                   disabled={isViewMode}
//                 >
//                   <SelectTrigger className="w-full text-[#020617] mt-2">
//                     <SelectValue placeholder="Select Header Type" />
//                   </SelectTrigger>
//                   <SelectContent>
//                     <SelectItem value="none" className="cursor-pointer">
//                       None
//                     </SelectItem>
//                     <SelectItem value="text" className="cursor-pointer">
//                       Text
//                     </SelectItem>
//                     <SelectItem value="image" className="cursor-pointer">
//                       Image
//                     </SelectItem>
//                     <SelectItem value="video" className="cursor-pointer">
//                       Video
//                     </SelectItem>
//                     <SelectItem value="document" className="cursor-pointer">
//                       Document
//                     </SelectItem>
//                   </SelectContent>
//                 </Select>
//               </div>

//               {/* Header Text Input */}
//               {headerType === "text" && (
//                 <div>
//                   <div className="flex justify-between">
//                     <Label>Header Text</Label>
//                     <div className="text-xs text-gray-500 mt-0">
//                       {textInput.length}/{maxLength}
//                     </div>
//                   </div>
//                   <Input
//                     value={textInput}
//                     onChange={(e) => {
//                       const value = e.target.value;
//                       setTextInput(value);
//                       validateHeaderText(value, language, setHeaderTextError);
//                     }}
//                     placeholder="Enter header text"
//                     className="mt-2 text-[#020617]"
//                     maxLength={60}
//                   />
//                   {isWhatsappContentSubmitAttempted && headerTextError && (
//                     <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
//                       {headerTextError}
//                     </p>
//                   )}
//                 </div>
//               )}

//               {/* Media Upload */}
//               {["image", "video", "document"].includes(headerType) && (
//                 <div>
//                   <Label>Upload {headerType}</Label>
//                   <div className="mt-2">
//                     <input
//                       ref={fileInputRef}
//                       type="file"
//                       onChange={handleFileChange}
//                       accept={
//                         headerType === "image"
//                           ? "image/jpeg,image/png"
//                           : headerType === "video"
//                             ? "video/mp4"
//                             : "application/pdf"
//                       }
//                       className="hidden"
//                       disabled={isViewMode}
//                     />
//                     <Button
//                       type="button"
//                       variant="outline"
//                       onClick={() => fileInputRef.current?.click()}
//                       className="w-full border-dashed border-2 h-20 text-[#020617]"
//                     >
//                       {selectedFile ? (
//                         <div className="text-center">
//                           <div className="font-medium">{selectedFile.name}</div>
//                           <div className="text-sm text-gray-500">
//                             {(selectedFile.size / 1024).toFixed(1)} KB
//                           </div>
//                         </div>
//                       ) : (
//                         <div className="text-center">
//                           <PlusIcon className="mx-auto h-6 w-6 mb-2" />
//                           Click to upload {headerType}
//                         </div>
//                       )}
//                     </Button>
//                     {selectedFile && (
//                       <div className="flex justify-end">
//                         <Button
//                           type="button"
//                           variant="ghost"
//                           onClick={() => {
//                             setSelectedFile(null);
//                             setPreviewImage(null);
//                             setMediaBase64("");
//                             if (fileInputRef.current) {
//                               fileInputRef.current.value = "";
//                             }
//                           }}
//                           className="text-red-500 mt-1 w-30 hover:text-red-700 hover:bg-red-50 flex justify-end"
//                           disabled={isViewMode}
//                         >
//                           <FaTrash className="mr-2" />
//                           Remove file
//                         </Button>
//                       </div>
//                     )}
//                   </div>

//                   {uploadError && (
//                     <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
//                       {uploadError}
//                     </p>
//                   )}
//                 </div>
//               )}

//               {/* Body Text */}
//               <div>
//                 <div className="flex justify-between">
//                   <Label>Body</Label>
//                   <div className="text-xs text-gray-500 mb-1 flex justify-end">
//                     {bodyText.length}/1024
//                   </div>
//                 </div>
//                 <div className="relative mt-2">
//                   <Textarea
//                     name="bodyText"
//                     className="w-full border rounded p-2 text-[#020617] pr-14 min-h-[120px] max-h-[120px] overflow-y-auto resize-none"
//                     maxLength={1024}
//                     value={bodyText}
//                     placeholder="Hello"
//                     onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
//                       const value = e.target.value;
//                       setBodyText(value);
//                       validateWhatsappBody(value, language, setWhatsappBodyError);
//                     }}
//                     disabled={isViewMode}
//                   />

//                   {isWhatsappContentSubmitAttempted && whatsappBodyError && (
//                     <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
//                       {whatsappBodyError}
//                     </p>
//                   )}
//                   <div className="absolute mt-2 right-2 flex gap-2">
//                     <Smile
//                       className="w-4 h-4 cursor-pointer text-gray-600 mb-4 hover:text-gray-800"
//                       onClick={() => setShowPicker(!showPicker)}
//                     />
//                     <FontBoldIcon
//                       className="w-4 h-4 cursor-pointer text-gray-600 hover:text-gray-800"
//                       onClick={() => insertFormattingTags("*", "*")}
//                     />
//                     <FontItalicIcon
//                       className="w-4 h-4 cursor-pointer text-gray-600 hover:text-gray-800"
//                       onClick={() => insertFormattingTags("_", "_")}
//                     />
//                     <Strikethrough
//                       className="w-4 h-4 cursor-pointer text-gray-600 hover:text-gray-800"
//                       onClick={() => insertFormattingTags("~", "~")}
//                     />
//                     <CodeIcon
//                       className="w-4 h-4 cursor-pointer text-gray-600 hover:text-gray-800"
//                       onClick={() => insertFormattingTags("`", "`")}
//                     />
//                   </div>

//                   {showPicker && (
//                     <div className="absolute top-full left-0 z-50 mt-2">
//                       <EmojiPicker onEmojiClick={onEmojiClick} />
//                     </div>
//                   )}
//                 </div>
//               </div>

//               {/* Footer */}
//               <div>
//                 <div className="flex justify-between mt-8">
//                   <div>
//                     <Label>Footer</Label>
//                     <div
//                       style={{
//                         background: "#F0F4F8",
//                         color: "#64748B",
//                         padding: "2px 10px",
//                         borderRadius: "9999px",
//                         display: "inline-flex",
//                         alignItems: "center",
//                         height: "20px",
//                         marginLeft: "8px",
//                         fontSize: "14px",
//                         fontWeight: 600,
//                       }}
//                     >
//                       Optional
//                     </div>
//                   </div>
//                   <div className="text-xs text-gray-500 mt-0 flex justify-end">
//                     {FooterText.length}/60
//                   </div>
//                 </div>
//                 <Input
//                   value={FooterText}
//                   onChange={(e) => {
//                     const value = e.target.value;
//                     setFooterText(value);
//                     validateWhatsappFooter(value, language, setWhatsappFooterError);
//                   }}
//                   placeholder="Enter footer text"
//                   className="mt-2 text-[#020617]"
//                   maxLength={60}
//                   disabled={isViewMode}
//                 />

//                 {isWhatsappContentSubmitAttempted && whatsappFooterError && (
//                   <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
//                     {whatsappFooterError}
//                   </p>
//                 )}
//               </div>

//               {/* Buttons Section */}
//               <div>
//                 <Label className="text-base font-semibold">Buttons</Label>
//                 <div
//                   style={{
//                     background: "#F0F4F8",
//                     color: "#64748B",
//                     padding: "2px 10px",
//                     borderRadius: "9999px",
//                     display: "inline-flex",
//                     alignItems: "center",
//                     height: "20px",
//                     marginLeft: "8px",
//                     fontSize: "14px",
//                     fontWeight: 600,
//                   }}
//                 >
//                   Optional
//                 </div>
//                 <div className="space-y-3 mt-2">
//                   {rows.map((row, index) => {

//                     // // ✅ Rule 2: Disable optOut checkbox on this row if any OTHER
//                     // // Quick Reply row already has optOut checked
//                     // const anyOtherOptOutChecked = rows.some(
//                     //   (r, i) =>
//                     //     i !== index &&
//                     //     r.buttonType === "QUICK_REPLY" &&
//                     //     r.optOut === true
//                     // );

//                     return (
//                       <div
//                         key={index}
//                         className="border rounded-lg p-4 bg-gray-50"
//                       >
//                         <div className="flex flex-col space-y-3">
//                           {/* Button Type and Text */}
//                           <div className="flex flex-col md:flex-row gap-3">
//                             <div className="flex-1">
//                               <Label className="text-sm">Action type</Label>
//                               <Select
//                                 value={row.buttonType}
//                                 onValueChange={(value) => {
//                                   updateButtonRow(index, "buttonType", value);
//                                   setButtonError(index, 'buttonType', null);
//                                   setTimeout(() => {
//                                     if (value) {
//                                       validateButtonType(value, index);
//                                     }
//                                   }, 0);
//                                 }}
//                                 disabled={isViewMode}
//                               >
//                                 <SelectTrigger className="text-[#020617] mt-1">
//                                   <SelectValue placeholder="Select action type" />
//                                 </SelectTrigger>
//                                 <SelectContent>
//                                   <SelectItem value="URL">View Website</SelectItem>
//                                   <SelectItem value="PHONE_NUMBER">Call Phone Number</SelectItem>
//                                   <SelectItem value="COPY_CODE">Copy Offer Code</SelectItem>
//                                   {/* <SelectItem value="QUICK_REPLY">Quick Reply</SelectItem> */}
//                                 </SelectContent>
//                               </Select>
//                               {isWhatsappContentSubmitAttempted && getButtonError(index, 'buttonType') && (
//                                 <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
//                                   {getButtonError(index, 'buttonType')}
//                                 </p>
//                               )}
//                             </div>

//                             <div className="flex-1">
//                               <div className="flex justify-between">
//                                 <Label className="text-sm">Button text</Label>
//                                 <div className="text-xs text-gray-500 mt-0 flex justify-end">
//                                   {(row.buttonType === "COPY_CODE" ? "Copy" : row.buttonText).length}/25
//                                 </div>
//                               </div>

//                               <Input
//                                 className="text-[#020617] mt-1"
//                                 placeholder="Button text"
//                                 value={row.buttonType === "COPY_CODE" ? "Copy" : row.buttonText}
//                                 onChange={(e) => {
//                                   const value = e.target.value;
//                                   updateButtonRow(index, "buttonText", value);
//                                 }}
//                                 maxLength={25}
//                                 disabled={row.buttonType === "COPY_CODE" || isViewMode}
//                               />

//                               {isWhatsappContentSubmitAttempted && getButtonError(index, 'buttonText') && (
//                                 <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
//                                   {getButtonError(index, 'buttonText')}
//                                 </p>
//                               )}
//                             </div>
//                           </div>

//                           {row.buttonType === "URL" && (
//                             <div>
//                               <Label className="text-sm">Website URL</Label>
//                               <Input
//                                 className="text-[#020617] mt-1"
//                                 placeholder="https://example.com"
//                                 value={row.websiteUrl}
//                                 onChange={(e) => {
//                                   const value = e.target.value;
//                                   updateButtonRow(index, "websiteUrl", value);
//                                   validateWebsiteUrl(value, index);
//                                   validateButtonsArray(rows);
//                                 }}
//                                 disabled={isViewMode}
//                               />
//                               {isWhatsappContentSubmitAttempted && getButtonError(index, 'websiteUrl') && (
//                                 <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
//                                   {getButtonError(index, 'websiteUrl')}
//                                 </p>
//                               )}
//                             </div>
//                           )}

//                           {row.buttonType === "PHONE_NUMBER" && (
//                             <div className="flex gap-3">
//                               <div className="w-36">
//                                 <Label className="text-sm">Country Code</Label>
//                                 <Select
//                                   value={row.countryCode}
//                                   onValueChange={(value) => {
//                                     updateButtonRow(index, "countryCode", value);
//                                     setButtonError(index, 'countryCode', null);
//                                     setTimeout(() => {
//                                       if (value) {
//                                         validateCountryCode(value, index);
//                                       }
//                                     }, 0);
//                                   }}
//                                   disabled={isViewMode}
//                                 >
//                                   <SelectTrigger className="text-[#020617] mt-1">
//                                     <SelectValue placeholder="Select Code" />
//                                   </SelectTrigger>
//                                   <SelectContent className="h-48">
//                                     {allCountryCodes.map((option) => (
//                                       <SelectItem
//                                         key={option.value}
//                                         value={option.value}
//                                         className="cursor-pointer"
//                                       >
//                                         {option.label}
//                                       </SelectItem>
//                                     ))}
//                                   </SelectContent>
//                                 </Select>
//                                 {isWhatsappContentSubmitAttempted && getButtonError(index, 'countryCode') && (
//                                   <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
//                                     {getButtonError(index, 'countryCode')}
//                                   </p>
//                                 )}
//                               </div>

//                               <div className="flex-1">
//                                 <Label className="text-sm">Phone Number</Label>
//                                 <Input
//                                   className="text-[#020617] mt-1"
//                                   placeholder="Phone number"
//                                   value={row.callPhoneNumber}
//                                   onChange={(e) => {
//                                     const value = e.target.value;
//                                     updateButtonRow(index, "callPhoneNumber", value);
//                                     setButtonError(index, 'callPhoneNumber', null);
//                                     setTimeout(() => {
//                                       if (value.trim()) {
//                                         validateCallPhoneNumber(value, index);
//                                       }
//                                     }, 0);
//                                     validateButtonsArray(rows);
//                                   }}
//                                   disabled={isViewMode}
//                                 />
//                                 {isWhatsappContentSubmitAttempted && getButtonError(index, 'callPhoneNumber') && (
//                                   <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
//                                     {getButtonError(index, 'callPhoneNumber')}
//                                   </p>
//                                 )}
//                               </div>
//                             </div>
//                           )}

//                           {row.buttonType === "COPY_CODE" && (
//                             <div>
//                               <div className="flex justify-between">
//                                 <Label className="text-sm">Offer Code</Label>
//                                 <div className="text-xs text-gray-500 mt-0 flex justify-end">
//                                   {row.copyOfferCode.length}/15
//                                 </div>
//                               </div>
//                               <Input
//                                 className="text-[#020617] mt-1"
//                                 placeholder="Offer code"
//                                 value={row.copyOfferCode}
//                                 onChange={(e) => {
//                                   const value = e.target.value;
//                                   updateButtonRow(index, "copyOfferCode", value);
//                                   setButtonError(index, 'offerCode', null);
//                                   setTimeout(() => {
//                                     if (value.trim()) {
//                                       validateOfferCode(value, index);
//                                     }
//                                   }, 0);
//                                   validateButtonsArray(rows);
//                                 }}
//                                 disabled={isViewMode}
//                                 maxLength={15}
//                               />
//                               {isWhatsappContentSubmitAttempted && getButtonError(index, 'offerCode') && (
//                                 <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
//                                   {getButtonError(index, 'offerCode')}
//                                 </p>
//                               )}
//                             </div>
//                           )}

//                           {/* Quick Reply Response - Only show for QUICK_REPLY type */}
//                           {/* {row.buttonType === 'QUICK_REPLY' && (
//                             <div>
//                               <div className="flex items-center justify-between mb-1">
//                                 <Label className="text-sm">Quick Reply Responses</Label>
//                                 <div className={`flex items-center space-x-2 ${anyOtherOptOutChecked ? "cursor-not-allowed" : ""}`}>
//                                   <input
//                                     type="checkbox"
//                                     id={`optout-${index}`}
//                                     className={`accent-[#3A85F7] w-3 h-3 ${anyOtherOptOutChecked ? "pointer-events-none opacity-50" : ""}`}
//                                     checked={row.optOut || false}
//                                     onChange={(e) => {
//                                       const updatedRows = [...rows];
//                                       updatedRows[index] = {
//                                         ...updatedRows[index],
//                                         optOut: e.target.checked
//                                       };
//                                       setRows(updatedRows);
//                                     }}
//                                     disabled={isViewMode || anyOtherOptOutChecked}
//                                   />
//                                   <Label
//                                     htmlFor={`optout-${index}`}
//                                     className={`text-sm font-normal ${anyOtherOptOutChecked ? "cursor-not-allowed text-gray-400" : "cursor-pointer"}`}
//                                   >
//                                     OptOut
//                                   </Label>
//                                 </div>
//                               </div>

//                               <Textarea
//                                 className={`text-[#020617] resize-none`}
//                                 placeholder="Enter quick reply response text..."
//                                 value={row.quickReplyResponse || ''}
//                                 onChange={(e) => {
//                                   const updatedRows = [...rows];
//                                   updatedRows[index] = {
//                                     ...updatedRows[index],
//                                     quickReplyResponse: e.target.value
//                                   };
//                                   setRows(updatedRows);
//                                 }}
//                                 rows={3}
//                                 disabled={isViewMode}
//                               />
//                             </div>
//                           )} */}

//                           {/* Remove button */}
//                           <div className="flex justify-end">
//                             <Button
//                               variant="ghost"
//                               size="sm"
//                               onClick={() => {
//                                 removeButtonRow(index);
//                               }}
//                               className="text-red-500 mt-0 w-30 hover:text-red-700 hover:bg-red-50 flex justify-end"
//                               disabled={isViewMode}
//                             >
//                               <FaTrash className="w-3 h-4 mr-2" /> Delete Button
//                             </Button>
//                           </div>
//                         </div>
//                       </div>
//                     );
//                   })}

//                   {/* Add Button */}
//                   {rows.length < 3 && (
//                     <Button
//                       variant="outline"
//                       onClick={() => {
//                         validateButtonsArray(rows);
//                         addButtonRow();
//                       }}
//                       className="w-full mt-2 text-[#3A85F7] border-[#3A85F7] hover:bg-blue-50"
//                       disabled={isViewMode}
//                     >
//                       <PlusIcon className="w-4 h-4 mr-2" />
//                       Add Button
//                     </Button>
//                   )}
//                 </div>
//               </div>
//             </div>

//             {isWhatsappContentSubmitAttempted && buttonsError && (
//               <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
//                 {buttonsError}
//               </p>
//             )}
//           </Card>
//         </div>

//         {/* Right Column - Preview */}
//         <div className="w-full md:w-2/5 max-w-[500px] border rounded-lg p-4 max-h-[750px] flex flex-col overflow-hidden">
//           <h2 className="mb-2 mt-0 font-bold text-left">Content Preview</h2>
//           <div
//             ref={previewRef}
//             className="rounded-2xl p-4 min-h-[350px] overflow-y-auto flex-1"
//             style={{
//               backgroundImage: `url(${Default_WhatsApp_background})`,
//               backgroundSize: "cover",
//               backgroundPosition: "center",
//               backgroundRepeat: "no-repeat",
//             }}
//           >
//             {noContentSelected ? (
//               <div className="flex w-full h-full items-center justify-center">
//                 <div className="text-center">
//                   <div>{textAreaIcon()}</div>
//                   <div className="mt-6">
//                     <p className="text-xl font-semibold">Mobile screen</p>
//                   </div>
//                   <div
//                     className="w-[125px] mt-2"
//                     style={{ fontWeight: 500, fontSize: "14px" }}
//                   >
//                   </div>
//                 </div>
//               </div>
//             ) : (
//               <>
//                 {/* Header Section */}
//                 {headerType === "text" && textInput && (
//                   <div className="font-semibold mb-2 text-lg">{textInput}</div>
//                 )}

//                 {headerType === "image" && previewImage && (
//                   <div className="mb-2">
//                     <img
//                       src={previewImage}
//                       alt="Header"
//                       className="w-full h-40 object-cover rounded-lg"
//                     />
//                   </div>
//                 )}

//                 {headerType === "video" && selectedFile && (
//                   <div className="mb-2">
//                     <video
//                       controls
//                       className="w-full h-40 object-cover rounded-lg"
//                       src={URL.createObjectURL(selectedFile)}
//                     >
//                       Your browser does not support the video tag.
//                     </video>
//                   </div>
//                 )}

//                 {headerType === "document" && selectedFile && (
//                   <div className="mb-2 p-3 bg-gray-100 rounded-lg flex items-center space-x-2">
//                     <FaFilePdf className="w-6 h-6 text-red-500" />
//                     <div>
//                       <div className="text-sm font-medium">
//                         {selectedFile.name}
//                       </div>
//                       <div className="text-xs text-gray-500">
//                         {(selectedFile.size / 1024).toFixed(1)} KB
//                       </div>
//                     </div>
//                   </div>
//                 )}

//                 {/* Body Section */}
//                 {bodyText && (
//                   <div
//                     className="mb-2 whitespace-pre-wrap break-words text-sm leading-relaxed"
//                     dangerouslySetInnerHTML={{
//                       __html: renderFormattedText(bodyText),
//                     }}
//                   />
//                 )}

//                 {/* Footer Section */}
//                 {FooterText && (
//                   <div className="text-gray-500 border-t pt-2 mt-3 text-xs flex justify-center">
//                     {FooterText}
//                   </div>
//                 )}

//                 {/* Buttons Section */}
//                 {rows.filter((row) => row.buttonText.trim()).length > 0 && (
//                   <div className="mt-3 space-y-2">
//                     {rows
//                       .filter((row) => row.buttonText.trim())
//                       .map((button, index) => (
//                         <p
//                           key={index}
//                           className="font-serif text-blue-400 flex justify-center"
//                           style={{ fontSize: "14px" }}
//                         >
//                           {button.buttonText}
//                           <div className="border-t mt-2"></div>
//                         </p>
//                       ))}
//                   </div>
//                 )}
//               </>
//             )}
//           </div>
//         </div>
//       </div>

//       <div className="flex justify-end space-x-3 -mt-8 mr-0 h-[40px]">
//         <Dialog>
//           <DialogTrigger asChild>
//             <Button
//               variant={"outline"}
//               className="w-[80px] border-red-500 text-red-500 hover:bg-red-500 hover:text-white mt-0"
//               disabled={isViewMode || isUpdateMode}
//             >
//               Discard
//             </Button>
//           </DialogTrigger>

//           <DialogContent className="sm:max-w-[425px]">
//             <DialogHeader>
//               <DialogDescription>
//                 Are you sure you want to discard this Template?
//               </DialogDescription>
//             </DialogHeader>

//             <DialogFooter>
//               <DialogClose asChild>
//                 <Button type="button" variant="outline" className="w-24">
//                   Cancel
//                 </Button>
//               </DialogClose>
//               <Button
//                 className="w-24"
//                 onClick={() => {
//                   resetWhatsappContent();
//                   onClose();
//                 }}
//                 autoFocus
//               >
//                 OK
//               </Button>
//             </DialogFooter>
//           </DialogContent>
//         </Dialog>
//         <Button
//           className="w-[100px] bg-[#3A85F7] text-white hover:bg-blue-600 mt-0"
//           onClick={() => {
//             setIsWhatsappContentSubmitAttempted(true);
//             handleSubmitWhatsApp();
//           }}
//           disabled={isViewMode}
//         >
//           Save
//         </Button>
//       </div>
//     </>
//   );
// };

// export default CreateContentWhatsapp;


/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, ChangeEvent, useRef, useCallback } from "react";
import { Button } from "../../../../Components/ui/button";
import Default_WhatsApp_background from "../../../../Assets/Default_WhatsApp_background.jpeg";
import { useToast } from "../../../../Components/ui/use-toast";
import { Toaster } from "../../../../Components/ui/toaster";
import { Combobox } from "../../../../Components/ui/combobox";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../../Components/ui/select";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../../Components/ui/dialog";
import { Input } from "../../../../Components/ui/input";
import CloseIcon from "@mui/icons-material/Close";
import { Label } from "../../../../Components/ui/label";
import { Textarea } from "../../../../Components/ui/textarea";
import { FaTrash, FaTimes, FaFilePdf, FaFileWord } from "react-icons/fa";
import { FaPlus, FaCaretDown } from "react-icons/fa";
import CancelIcon from "@mui/icons-material/Cancel";
import { Add as AddIcon } from "@mui/icons-material";
import EmojiPicker from "emoji-picker-react"


import {
  Container,
  Box,
  Typography,
  TextField,
  IconButton,
  CircularProgress,
} from "@mui/material";
import {
  ChevronDownIcon,
  PlusIcon,
  InfoCircledIcon,
  FontBoldIcon,
  FontItalicIcon,
  CodeIcon,
} from "@radix-ui/react-icons";
import { CheckIcon } from "@radix-ui/react-icons";
import { Card } from "../../../../Components/ui/card";
import { Smile, Strikethrough } from "lucide-react";
import { Document, Page } from "react-pdf";
import { useCampaignContext } from "../CampaignContext";
import axios, { AxiosResponse } from "axios";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "@/src/State/store";
import { useCampaignValidators } from "../hooks/useCampaignValidators";


interface BoxItem {
  action: string;
}

interface Language {
  language_id: number;
  language_name: string;
  language_code: string;
}

interface Country {
  country_id: number;
  country_code: number;
  country_name: string;
  country_shortname: string;
}

interface GetButtonTypeList {
  button_id: number;
  button_type: string;
}

interface Template {
  template_id: number;
  template_name: string;
}

interface Content {
  content_id: number;
  content_name: string;
}

interface RowData {
  buttonType: string;
  buttonText: string;
  buttonTypeDropdown: string;
  websiteUrl: string;
  countryCode: string;
  callPhoneNumber: string;
  copyOfferCode: string;
  quickReplyResponse?: string;
  // optOut?: boolean;
}

interface Channel {
  channel_id: number;
  channel_name: string;
}

const textAreaIcon = () => {
  return (
    <div className="relative w-8 h-8 flex justify-center items-center">
      <div
        className="absolute rounded w-[3px] h-8 transform rotate-45"
        style={{ borderLeft: "3px solid #64748B" }}
      />
      <div
        className="absolute w-[3px] h-4 rounded transform rotate-45 translate-x-2 translate-y-2"
        style={{ borderLeft: "3px solid #64748B" }}
      />
    </div>
  );
};

interface CreateContentWhatsapp {
  onClose: () => void;
}

const CreateContentWhatsapp: React.FC<CreateContentWhatsapp> = ({
  onClose,
}) => {
  const [languageList, setLanguageList] = useState<Language[]>([]);
  const [countryList, setCountryList] = useState<Country[]>([]);

  const [Content, setContent] = useState("");
  const [ContentList, setContentList] = useState<Content[]>([]);
  const [buttonType, setButtonType] = useState("");
  const [buttonList, setButtonList] = useState<GetButtonTypeList[]>([]);
  const [templateList, setTemplateList] = useState<Template[]>([]);
  const [templateName, setTemplateName] = useState("");
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [templateName1, setTemplateName1] = useState("");
  const [file, setFile] = useState<File | null>(null);
  const [buttonT, setButtonT] = useState<number>(0);
  const [senderName, setSenderName] = useState("");
  const [templatePreview, setTemplatePreview] = useState<string>("");
  const [buttonData, setButtonData] = useState<{
    buttonText: string;
    websiteUrl: string;
  }>({
    buttonText: "",
    websiteUrl: "",
  });
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const [selectedAction, setSelectedAction] = useState<string | null>(null);
  const [buttonTypeDropdown, setButtonTypeDropdown] =
    useState<string>("static");
  const [buttonText, setButtonText] = useState<string>("");
  const [websiteUrl, setWebsiteUrl] = useState<string>("");
  const [boxes, setBoxes] = useState<BoxItem[]>([]);
  const [channelList, setChannelList] = useState<Channel[]>([]);
  const [channel, setChannel] = useState("");
  const [templateType, setTemplateType] = useState("");
  const [PlatformNameError, setPlatformNameError] = useState<string | null>(
    null
  );
  const [templateError, setTemplateError] = useState<string | null>(null);
  const [LanguageError, setLanguageError] = useState<string | null>(null);
  const [channelError, setChannelError] = useState<string | null>(null);
  const [BodyError, setBodyError] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [showFileInput, setShowFileInput] = useState(true);
  const [warning, setWarning] = useState("");
  const [selectedButtonIds, setSelectedButtonIds] = useState<string[]>([]);
  const [websiteUrls, setWebsiteUrls] = useState<string[]>([]);
  const maxLength = 60;
  const [headerHandle, setHeaderHandle] = useState("");
  const [inputStr, setInputStr] = useState("");
  const [showPicker, setShowPicker] = useState(false);
  const previewRef = useRef<HTMLDivElement>(null);
  const [isFixed, setIsFixed] = useState(true);

  //Present
  const [languageOptions, setLanguageOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const [allCountryCodes, setAllCountryCodes] = useState<
    { label: string; value: string }[]
  >([]);

  const {
    setWhatsappContent,
    campaignName,
    setLanguage,
    language,
    setBodyText,
    bodyText,
    setFooterText,
    FooterText,
    headerType,
    setHeaderType,
    textInput,
    setTextInput,
    setSelectedFile,
    selectedFile,
    setPreviewImage,
    previewImage,
    rows,
    setRows,
    setIsWhatsappContentSubmitAttempted,
    isWhatsappContentSubmitAttempted,
    languageError,
    phoneNumberError,
    whatsappBodyError,
    resetWhatsappContent,
    setUploadError,
    uploadError,
    setFileName,
    fileName,
    setFileLength,
    fileLength,
    setFileType,
    fileType,
    setMediaBase64,
    mediaBase64,
    setSelectedOption,
    selectedOption,
    headerTextError,
    whatsappFooterError,
    // Button validation error states from context
    buttonValidationErrors,
    getButtonError,
    setButtonError,
    clearButtonErrors,
    buttonsError,
    isViewMode,
    setWhatsappBodyError,
    setHeaderTextError,
    setWhatsappFooterError,
    isUpdateMode
  } = useCampaignContext();

  const apiUrlAdvAcc = useSelector(
    (state: RootState) => state.authentication.apiURL
  );
  const workspaceId = useSelector((state: RootState) => state.authentication.workspace_id);

  const {
    validateLanguage,
    validatePhoneNumber,
    validateWhatsappBody,
    validateHeaderText,
    validateWhatsappFooter,
    validateButtonText,
    validateWebsiteUrl,
    validateCallPhoneNumber,
    validateCountryCode,
    validateOfferCode,
    validateButtonType,
    validateButtonsArray
  } = useCampaignValidators();

  const toast = useToast();

  const dispatch = useDispatch();

  useEffect(() => {
    GetAllCountryCodes();
    GetLanguages();
  }, []);

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    if (file) {
      debugger;

      const fileLimit = Number(process.env.REACT_APP_FILE_UPLOAD_LIMIT);
      const maxSizeInBytes = fileLimit * 1024 * 1024;

      if (file.size > maxSizeInBytes) {
        setUploadError(`Only files up to ${fileLimit}MB are allowed.`);
        event.target.value = "";
        return;
      }

      const testreader = new FileReader();
      testreader.onload = () => {
        const base64String = testreader.result as string;
      };
      testreader.readAsDataURL(file);

      const ext = file.name.split(".").pop()?.toLowerCase() || "";

      const allowedImageExts = ["jpeg", "jpg", "png"];
      const allowedVideoExts = ["mp4"];
      const allowedDocExts = ["pdf"];

      const isImage =
        file.type.startsWith("image/") && allowedImageExts.includes(ext);
      const isVideo =
        file.type === "video/mp4" && allowedVideoExts.includes(ext);
      const isPdf =
        file.type === "application/pdf" && allowedDocExts.includes(ext);

      if (!isImage && !isVideo && !isPdf) {
        setUploadError(
          "Only JPG, JPEG, PNG images, MP4 videos, or PDF documents are allowed."
        );
        event.target.value = "";
        return;
      }

      setUploadError(null);

      setSelectedFile(file);
      setFileName(file.name);
      setFileLength(file.size.toString());
      setFileType(file.type);

      if (isImage) {
        const reader = new FileReader();
        reader.onload = (e) => {
          setPreviewImage(e.target?.result as string);
        };
        reader.readAsDataURL(file);
      }

      debugger;

      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result as string;
        setMediaBase64(base64String);
      };
      reader.readAsDataURL(file);
    }
  };

  const onEmojiClick = (emojiObject: any) => {
    setBodyText((prev) => prev + emojiObject.emoji);
    setShowPicker(false);
  };

  const insertFormattingTags = (startTag: string, endTag: string) => {
    const textarea = document.querySelector(
      'textarea[name="bodyText"]'
    ) as HTMLTextAreaElement;
    if (!textarea) return;

    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const selectedText = textarea.value.substring(start, end);
    const replacement = startTag + selectedText + endTag;

    const newValue =
      textarea.value.substring(0, start) +
      replacement +
      textarea.value.substring(end);
    setBodyText(newValue);

    setTimeout(() => {
      textarea.focus();
      textarea.setSelectionRange(
        start + startTag.length,
        start + startTag.length + selectedText.length
      );
    }, 0);
  };

  const addButtonRow = () => {
    if (rows.length < 3) {
      const newRow: RowData = {
        buttonType: "",
        buttonText: "",
        buttonTypeDropdown: "static",
        websiteUrl: "",
        countryCode: "",
        callPhoneNumber: "",
        copyOfferCode: "",
        quickReplyResponse: "",
        // optOut: false
      };
      setRows([...rows, newRow]);
    }
  };

  const removeButtonRow = (index: number) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
    clearButtonErrors(index);
  };

  const updateButtonRow = (
    index: number,
    field: keyof RowData,
    value: string
  ) => {
    const updatedRows = rows.map((row, i) => {
      if (i === index) {
        const updatedRow = { ...row, [field]: value };

        if (field === "buttonType") {
          switch (value) {
            case "COPY_CODE":
              updatedRow.buttonText = "Copy";
              break;
            case "URL":
            case "PHONE_NUMBER":
              if (row.buttonType === "COPY_CODE") {
                updatedRow.buttonText = "";
              }
              break;
            default:
              break;
          }
        }

        return updatedRow;
      }
      return row;
    });
    setRows(updatedRows);
  };

  const renderFormattedText = (text: string) => {
    return text
      .replace(/\*([^*]+)\*/g, "<strong>$1</strong>")
      .replace(/_([^_]+)_/g, "<em>$1</em>")
      .replace(/~([^~]+)~/g, "<s>$1</s>")
      .replace(
        /`([^`]+)`/g,
        '<code style="background: #f1f1f1; padding: 2px 4px; border-radius: 3px;">$1</code>'
      )
      .replace(
        /\{\{(\d+)\}\}/g,
        '<span style="background: #e3f2fd; padding: 2px 4px; border-radius: 3px; color: #1976d2;">{{$1}}</span>'
      );
  };

  const noContentSelected =
    !textInput.trim() &&
    !previewImage &&
    !selectedFile &&
    !bodyText.trim() &&
    !FooterText.trim() &&
    rows.filter((row) => row.buttonText.trim()).length === 0;

  const handleSubmitWhatsApp = async () => {
    const [
      isLanguageValid,
      isBodyValid,
      isHeaderTextValid,
      isFooterTextValid,
      isButtonsValid
    ] = await Promise.all([
      Promise.resolve(validateLanguage(language)),
      Promise.resolve(validateWhatsappBody(bodyText, language, setWhatsappBodyError)),
      Promise.resolve(validateHeaderText(textInput, language, setHeaderTextError)),
      Promise.resolve(validateWhatsappFooter(FooterText, language, setWhatsappFooterError)),
      Promise.resolve(validateButtonsArray(rows)),
    ]);

    const isFormValid =
      isLanguageValid &&
      isBodyValid &&
      isHeaderTextValid &&
      isFooterTextValid &&
      isButtonsValid;

    console.log("Form valid", isFormValid);

    if (!isFormValid) {
      toast.toast({
        title: "Validation Failed",
        description: "Please correct the highlighted errors before saving.",
      });
      return;
    }

    // const templateName = `${campaignName.toLocaleLowerCase()}_whatsapp_${workspaceId}`;

    const templateName = `${campaignName.toLocaleLowerCase().replace(/\s+/g, '')}_whatsapp_${workspaceId}`;

    const rawComponents: any[] = [];

    if (selectedOption && selectedOption !== "none") {
      const headerObj: any = {
        type: "HEADER",
        format: headerType?.toUpperCase(),
      };

      if (headerType === "text" && textInput) {
        headerObj.text = textInput;
      } else if (["image", "video", "document"].includes(headerType)) {
        headerObj.example = { header_handle: [headerHandle] };
      }

      rawComponents.push(headerObj);
    }

    rawComponents.push({
      type: "BODY",
      text: bodyText,
    });

    if (FooterText) {
      rawComponents.push({
        type: "FOOTER",
        text: FooterText,
      });
    }

    const buttons = rows
      .filter((row) => row.buttonText.trim())
      .map((row) => {
        if (row.buttonType === "URL") {
          return {
            type: "URL",
            text: row.buttonText,
            url: row.websiteUrl,
          };
        } else if (row.buttonType === "PHONE_NUMBER") {
          return {
            type: "PHONE_NUMBER",
            text: row.buttonText,
            phone_number: row.countryCode + row.callPhoneNumber,
          };
        } else if (["COPY_CODE"].includes(row.buttonType)) {
          return {
            type: "COPY_CODE",
            example: row.copyOfferCode,
          };
        }
        else if (row.buttonType === "QUICK_REPLY") {
          return {
            type: "QUICK_REPLY",
            text: row.buttonText,
          };
        }
        return {};
      });

    if (buttons.length > 0) {
      rawComponents.push({
        type: "BUTTONS",
        buttons,
      });
    }

    const qrArray = rows
      .filter((row) => row.buttonType === "QUICK_REPLY" && row.buttonText.trim())
      .map((row) => ({
        label: row.buttonText,
        response: row.quickReplyResponse,
        // opt_out: row.optOut ?? false,
      }));

    const template: any = {
      name: templateName,
      language: language,
      category: "MARKETING",
      components: JSON.stringify(rawComponents),
    };

    debugger

    const finalWhatsappPayload = {
      template: {
        channel_id: 1,
        channel_type: "Whatsapp",
        part_count: 1,
        campaign_name: campaignName,
        media_config: {
          file_name: fileName,
          file_length: fileLength,
          file_type: fileType,
          binary_data: mediaBase64,
        },
        template_content: template,
        ...(qrArray.length > 0 && { QR: qrArray }),
      }
    };

    setWhatsappContent(finalWhatsappPayload);
    onClose();
  };

  //APIs
  const GetAllCountryCodes = async () => {
    try {
      const response = await axios.get(`${apiUrlAdvAcc}/GetAllCountryCodes`);

      if (
        response.data?.status === "Success" &&
        Array.isArray(response.data.country_codes)
      ) {
        const options = response.data.country_codes;
        setAllCountryCodes(options);
      } else {
      }
    } catch (error) {
    }
  };

  const GetLanguages = async () => {
    try {
      const response = await axios.get(`${apiUrlAdvAcc}/GetLanguages`);

      if (
        response.data?.status === "Success" &&
        Array.isArray(response.data.languages)
      ) {
        setLanguageOptions(response.data.languages);
      } else {
      }
    } catch (error) {
    }
  };

  const useDebounce = (callback: Function, delay: number) => {
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    return useCallback((...args: any[]) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => callback(...args), delay);
    }, [callback, delay]);
  };

  useEffect(() => {
    if (rows.length > 0) {
      validateButtonsArray(rows);
    }
  }, [rows]);

  useEffect(() => {
    rows.forEach((_, index) => {
      clearButtonErrors(index);
    });

    const timeoutId = setTimeout(() => {
      if (rows.length > 0) {
        validateButtonsArray(rows).catch(error => {
          console.error("Validation error:", error);
        });
      }
    }, 100);

    return () => clearTimeout(timeoutId);
  }, [language]);

  return (
    <>
      <div className="flex flex-col md:flex-row gap-6 mb-6 mt-4">
        {/* Left Column - Form */}
        <div className="space-y-6 w-full md:w-3/5">
          {/* Content Card */}
          <Card className="border p-4 rounded-lg text-left">
            <h2 className="text-base font-semibold mb-2">Content</h2>

            <div className="flex-shrink-0">
              <Label htmlFor="language">Language</Label>
              <Combobox
                value={language}
                onChange={(val) => {
                  setLanguage(val);
                  validateLanguage(val);
                  validateWhatsappBody(bodyText, val, setWhatsappBodyError);
                  validateWhatsappFooter(FooterText, val, setWhatsappFooterError);
                  validateHeaderText(textInput, val, setHeaderTextError);
                  validateButtonsArray(rows);
                }}
                options={languageOptions ?? []}
                placeholder="Select Language"
                disabled={isViewMode}
              />

              {isWhatsappContentSubmitAttempted && languageError && (
                <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
                  {languageError}
                </p>
              )}
            </div>

            <div className="space-y-4 mt-4">
              {/* Header Type Selection */}
              <div>
                <Label>Header Type</Label>
                <div
                  style={{
                    background: "#F0F4F8",
                    color: "#64748B",
                    padding: "2px 10px",
                    borderRadius: "9999px",
                    display: "inline-flex",
                    alignItems: "center",
                    height: "20px",
                    marginLeft: "8px",
                    fontSize: "14px",
                    fontWeight: 600,
                  }}
                >
                  Optional
                </div>
                <Select
                  value={headerType}
                  onValueChange={(value) => {
                    setHeaderType(value);
                    setSelectedOption(value);
                    if (value !== "text") {
                      setTextInput("");
                    }
                    if (!["image", "video", "document"].includes(value)) {
                      setSelectedFile(null);
                      setPreviewImage(null);
                    }
                  }}
                  disabled={isViewMode}
                >
                  <SelectTrigger className="w-full text-[#020617] mt-2">
                    <SelectValue placeholder="Select Header Type" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="none" className="cursor-pointer">
                      None
                    </SelectItem>
                    <SelectItem value="text" className="cursor-pointer">
                      Text
                    </SelectItem>
                    <SelectItem value="image" className="cursor-pointer">
                      Image
                    </SelectItem>
                    <SelectItem value="video" className="cursor-pointer">
                      Video
                    </SelectItem>
                    <SelectItem value="document" className="cursor-pointer">
                      Document
                    </SelectItem>
                  </SelectContent>
                </Select>
              </div>

              {/* Header Text Input */}
              {headerType === "text" && (
                <div>
                  <div className="flex justify-between">
                    <Label>Header Text</Label>
                    <div className="text-xs text-gray-500 mt-0">
                      {textInput.length}/{maxLength}
                    </div>
                  </div>
                  <Input
                    value={textInput}
                    onChange={(e) => {
                      const value = e.target.value;
                      setTextInput(value);
                      validateHeaderText(value, language, setHeaderTextError);
                    }}
                    placeholder="Enter header text"
                    className="mt-2 text-[#020617]"
                    maxLength={60}
                  />
                  {isWhatsappContentSubmitAttempted && headerTextError && (
                    <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
                      {headerTextError}
                    </p>
                  )}
                </div>
              )}

              {/* Media Upload */}
              {["image", "video", "document"].includes(headerType) && (
                <div>
                  <Label>Upload {headerType}</Label>
                  <div className="mt-2">
                    <input
                      ref={fileInputRef}
                      type="file"
                      onChange={handleFileChange}
                      accept={
                        headerType === "image"
                          ? "image/jpeg,image/png"
                          : headerType === "video"
                            ? "video/mp4"
                            : "application/pdf"
                      }
                      className="hidden"
                      disabled={isViewMode}
                    />
                    <Button
                      type="button"
                      variant="outline"
                      onClick={() => fileInputRef.current?.click()}
                      className="w-full border-dashed border-2 h-20 text-[#020617]"
                    >
                      {selectedFile ? (
                        <div className="text-center">
                          <div className="font-medium">{selectedFile.name}</div>
                          <div className="text-sm text-gray-500">
                            {(selectedFile.size / 1024).toFixed(1)} KB
                          </div>
                        </div>
                      ) : (
                        <div className="text-center">
                          <PlusIcon className="mx-auto h-6 w-6 mb-2" />
                          Click to upload {headerType}
                        </div>
                      )}
                    </Button>
                    {selectedFile && (
                      <div className="flex justify-end">
                        <Button
                          type="button"
                          variant="ghost"
                          onClick={() => {
                            setSelectedFile(null);
                            setPreviewImage(null);
                            setMediaBase64("");
                            if (fileInputRef.current) {
                              fileInputRef.current.value = "";
                            }
                          }}
                          className="text-red-500 mt-1 w-30 hover:text-red-700 hover:bg-red-50 flex justify-end"
                          disabled={isViewMode}
                        >
                          <FaTrash className="mr-2" />
                          Remove file
                        </Button>
                      </div>
                    )}
                  </div>

                  {uploadError && (
                    <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
                      {uploadError}
                    </p>
                  )}
                </div>
              )}

              {/* Body Text */}
              <div>
                <div className="flex justify-between">
                  <Label>Body</Label>
                  <div className="text-xs text-gray-500 mb-1 flex justify-end">
                    {bodyText.length}/1024
                  </div>
                </div>
                <div className="relative mt-2">
                  <Textarea
                    name="bodyText"
                    className="w-full border rounded p-2 text-[#020617] pr-14 min-h-[120px] max-h-[120px] overflow-y-auto resize-none"
                    maxLength={1024}
                    value={bodyText}
                    placeholder="Hello"
                    onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                      const value = e.target.value;
                      setBodyText(value);
                      validateWhatsappBody(value, language, setWhatsappBodyError);
                    }}
                    disabled={isViewMode}
                  />

                  {isWhatsappContentSubmitAttempted && whatsappBodyError && (
                    <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
                      {whatsappBodyError}
                    </p>
                  )}
                  <div className="absolute mt-2 right-2 flex gap-2">
                    <Smile
                      className="w-4 h-4 cursor-pointer text-gray-600 mb-4 hover:text-gray-800"
                      onClick={() => setShowPicker(!showPicker)}
                    />
                    <FontBoldIcon
                      className="w-4 h-4 cursor-pointer text-gray-600 hover:text-gray-800"
                      onClick={() => insertFormattingTags("*", "*")}
                    />
                    <FontItalicIcon
                      className="w-4 h-4 cursor-pointer text-gray-600 hover:text-gray-800"
                      onClick={() => insertFormattingTags("_", "_")}
                    />
                    <Strikethrough
                      className="w-4 h-4 cursor-pointer text-gray-600 hover:text-gray-800"
                      onClick={() => insertFormattingTags("~", "~")}
                    />
                    <CodeIcon
                      className="w-4 h-4 cursor-pointer text-gray-600 hover:text-gray-800"
                      onClick={() => insertFormattingTags("`", "`")}
                    />
                  </div>

                  {showPicker && (
                    <div className="absolute top-full left-0 z-50 mt-2">
                      <EmojiPicker onEmojiClick={onEmojiClick} />
                    </div>
                  )}
                </div>
              </div>

              {/* Footer */}
              <div>
                <div className="flex justify-between mt-8">
                  <div>
                    <Label>Footer</Label>
                    <div
                      style={{
                        background: "#F0F4F8",
                        color: "#64748B",
                        padding: "2px 10px",
                        borderRadius: "9999px",
                        display: "inline-flex",
                        alignItems: "center",
                        height: "20px",
                        marginLeft: "8px",
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                      Optional
                    </div>
                  </div>
                  <div className="text-xs text-gray-500 mt-0 flex justify-end">
                    {FooterText.length}/60
                  </div>
                </div>
                <Input
                  value={FooterText}
                  onChange={(e) => {
                    const value = e.target.value;
                    setFooterText(value);
                    validateWhatsappFooter(value, language, setWhatsappFooterError);
                  }}
                  placeholder="Enter footer text"
                  className="mt-2 text-[#020617]"
                  maxLength={60}
                  disabled={isViewMode}
                />

                {isWhatsappContentSubmitAttempted && whatsappFooterError && (
                  <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
                    {whatsappFooterError}
                  </p>
                )}
              </div>

              {/* Buttons Section */}
              <div>
                <Label className="text-base font-semibold">Buttons</Label>
                <div
                  style={{
                    background: "#F0F4F8",
                    color: "#64748B",
                    padding: "2px 10px",
                    borderRadius: "9999px",
                    display: "inline-flex",
                    alignItems: "center",
                    height: "20px",
                    marginLeft: "8px",
                    fontSize: "14px",
                    fontWeight: 600,
                  }}
                >
                  Optional
                </div>
                <div className="space-y-3 mt-2">
                  {rows.map((row, index) => {

                    return (
                      <div
                        key={index}
                        className="border rounded-lg p-4 bg-gray-50"
                      >
                        <div className="flex flex-col space-y-3">
                          {/* Button Type and Text */}
                          <div className="flex flex-col md:flex-row gap-3">
                            <div className="flex-1">
                              <Label className="text-sm">Action type</Label>
                              <Select
                                value={row.buttonType}
                                onValueChange={(value) => {
                                  updateButtonRow(index, "buttonType", value);
                                  setButtonError(index, 'buttonType', null);
                                  setTimeout(() => {
                                    if (value) {
                                      validateButtonType(value, index);
                                    }
                                  }, 0);
                                }}
                                disabled={isViewMode}
                              >
                                <SelectTrigger className="text-[#020617] mt-1">
                                  <SelectValue placeholder="Select action type" />
                                </SelectTrigger>
                                <SelectContent>
                                  <SelectItem value="URL">View Website</SelectItem>
                                  <SelectItem value="PHONE_NUMBER">Call Phone Number</SelectItem>
                                  <SelectItem value="COPY_CODE">Copy Offer Code</SelectItem>
                                  <SelectItem value="QUICK_REPLY">Quick Reply</SelectItem>
                                </SelectContent>
                              </Select>
                              {isWhatsappContentSubmitAttempted && getButtonError(index, 'buttonType') && (
                                <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
                                  {getButtonError(index, 'buttonType')}
                                </p>
                              )}
                            </div>

                            <div className="flex-1">
                              <div className="flex justify-between">
                                <Label className="text-sm">Button text</Label>
                                <div className="text-xs text-gray-500 mt-0 flex justify-end">
                                  {(row.buttonType === "COPY_CODE" ? "Copy" : row.buttonText).length}/25
                                </div>
                              </div>

                              <Input
                                className="text-[#020617] mt-1"
                                placeholder="Button text"
                                value={row.buttonType === "COPY_CODE" ? "Copy" : row.buttonText}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  updateButtonRow(index, "buttonText", value);
                                }}
                                maxLength={25}
                                disabled={row.buttonType === "COPY_CODE" || isViewMode}
                              />

                              {isWhatsappContentSubmitAttempted && getButtonError(index, 'buttonText') && (
                                <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
                                  {getButtonError(index, 'buttonText')}
                                </p>
                              )}
                            </div>
                          </div>

                          {row.buttonType === "URL" && (
                            <div>
                              <Label className="text-sm">Website URL</Label>
                              <Input
                                className="text-[#020617] mt-1"
                                placeholder="https://example.com"
                                value={row.websiteUrl}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  updateButtonRow(index, "websiteUrl", value);
                                  validateWebsiteUrl(value, index);
                                  validateButtonsArray(rows);
                                }}
                                disabled={isViewMode}
                              />
                              {isWhatsappContentSubmitAttempted && getButtonError(index, 'websiteUrl') && (
                                <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
                                  {getButtonError(index, 'websiteUrl')}
                                </p>
                              )}
                            </div>
                          )}

                          {row.buttonType === "PHONE_NUMBER" && (
                            <div className="flex gap-3">
                              <div className="w-36">
                                <Label className="text-sm">Country Code</Label>
                                <Select
                                  value={row.countryCode}
                                  onValueChange={(value) => {
                                    updateButtonRow(index, "countryCode", value);
                                    setButtonError(index, 'countryCode', null);
                                    setTimeout(() => {
                                      if (value) {
                                        validateCountryCode(value, index);
                                      }
                                    }, 0);
                                  }}
                                  disabled={isViewMode}
                                >
                                  <SelectTrigger className="text-[#020617] mt-1">
                                    <SelectValue placeholder="Select Code" />
                                  </SelectTrigger>
                                  <SelectContent className="h-48">
                                    {allCountryCodes.map((option) => (
                                      <SelectItem
                                        key={option.value}
                                        value={option.value}
                                        className="cursor-pointer"
                                      >
                                        {option.label}
                                      </SelectItem>
                                    ))}
                                  </SelectContent>
                                </Select>
                                {isWhatsappContentSubmitAttempted && getButtonError(index, 'countryCode') && (
                                  <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
                                    {getButtonError(index, 'countryCode')}
                                  </p>
                                )}
                              </div>

                              <div className="flex-1">
                                <Label className="text-sm">Phone Number</Label>
                                <Input
                                  className="text-[#020617] mt-1"
                                  placeholder="Phone number"
                                  value={row.callPhoneNumber}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    updateButtonRow(index, "callPhoneNumber", value);
                                    setButtonError(index, 'callPhoneNumber', null);
                                    setTimeout(() => {
                                      if (value.trim()) {
                                        validateCallPhoneNumber(value, index);
                                      }
                                    }, 0);
                                    validateButtonsArray(rows);
                                  }}
                                  disabled={isViewMode}
                                />
                                {isWhatsappContentSubmitAttempted && getButtonError(index, 'callPhoneNumber') && (
                                  <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
                                    {getButtonError(index, 'callPhoneNumber')}
                                  </p>
                                )}
                              </div>
                            </div>
                          )}

                          {row.buttonType === "COPY_CODE" && (
                            <div>
                              <div className="flex justify-between">
                                <Label className="text-sm">Offer Code</Label>
                                <div className="text-xs text-gray-500 mt-0 flex justify-end">
                                  {row.copyOfferCode.length}/15
                                </div>
                              </div>
                              <Input
                                className="text-[#020617] mt-1"
                                placeholder="Offer code"
                                value={row.copyOfferCode}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  updateButtonRow(index, "copyOfferCode", value);
                                  setButtonError(index, 'offerCode', null);
                                  setTimeout(() => {
                                    if (value.trim()) {
                                      validateOfferCode(value, index);
                                    }
                                  }, 0);
                                  validateButtonsArray(rows);
                                }}
                                disabled={isViewMode}
                                maxLength={15}
                              />
                              {isWhatsappContentSubmitAttempted && getButtonError(index, 'offerCode') && (
                                <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
                                  {getButtonError(index, 'offerCode')}
                                </p>
                              )}
                            </div>
                          )}

                          {/* Quick Reply Response - Only show for QUICK_REPLY type */}
                          {row.buttonType === 'QUICK_REPLY' && (
                            <div>
                              <div className="flex items-center justify-between mb-1">
                                <Label className="text-sm">Quick Reply Responses</Label>
                                {/* OptOut checkbox removed */}
                              </div>

                              {/* Textarea below */}
                              <Textarea
                                className={`text-[#020617] resize-none`}
                                placeholder="Enter quick reply response text..."
                                value={row.quickReplyResponse || ''}
                                onChange={(e) => {
                                  const updatedRows = [...rows];
                                  updatedRows[index] = {
                                    ...updatedRows[index],
                                    quickReplyResponse: e.target.value
                                  };
                                  setRows(updatedRows);
                                }}
                                rows={3}
                                disabled={isViewMode}
                              />
                            </div>
                          )}

                          {/* Remove button */}
                          <div className="flex justify-end">
                            <Button
                              variant="ghost"
                              size="sm"
                              onClick={() => {
                                removeButtonRow(index);
                              }}
                              className="text-red-500 mt-0 w-30 hover:text-red-700 hover:bg-red-50 flex justify-end"
                              disabled={isViewMode}
                            >
                              <FaTrash className="w-3 h-4 mr-2" /> Delete Button
                            </Button>
                          </div>
                        </div>
                      </div>
                    );
                  })}

                  {/* Add Button */}
                  {rows.length < 3 && (
                    <Button
                      variant="outline"
                      onClick={() => {
                        validateButtonsArray(rows);
                        addButtonRow();
                      }}
                      className="w-full mt-2 text-[#3A85F7] border-[#3A85F7] hover:bg-blue-50"
                      disabled={isViewMode}
                    >
                      <PlusIcon className="w-4 h-4 mr-2" />
                      Add Button
                    </Button>
                  )}
                </div>
              </div>
            </div>

            {isWhatsappContentSubmitAttempted && buttonsError && (
              <p className="text-red-500 text-xs font-medium mt-1 font-sans italic ml-1 text-left">
                {buttonsError}
              </p>
            )}
          </Card>
        </div>

        {/* Right Column - Preview */}
        <div className="w-full md:w-2/5 max-w-[500px] border rounded-lg p-4 max-h-[750px] flex flex-col overflow-hidden">
          <h2 className="mb-2 mt-0 font-bold text-left">Content Preview</h2>
          <div
            ref={previewRef}
            className="rounded-2xl p-4 min-h-[350px] overflow-y-auto flex-1"
            style={{
              backgroundImage: `url(${Default_WhatsApp_background})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            {noContentSelected ? (
              <div className="flex w-full h-full items-center justify-center">
                <div className="text-center">
                  <div>{textAreaIcon()}</div>
                  <div className="mt-6">
                    <p className="text-xl font-semibold">Mobile screen</p>
                  </div>
                  <div
                    className="w-[125px] mt-2"
                    style={{ fontWeight: 500, fontSize: "14px" }}
                  >
                  </div>
                </div>
              </div>
            ) : (
              <>
                {/* Header Section */}
                {headerType === "text" && textInput && (
                  <div className="font-semibold mb-2 text-lg">{textInput}</div>
                )}

                {headerType === "image" && previewImage && (
                  <div className="mb-2">
                    <img
                      src={previewImage}
                      alt="Header"
                      className="w-full h-40 object-cover rounded-lg"
                    />
                  </div>
                )}

                {headerType === "video" && selectedFile && (
                  <div className="mb-2">
                    <video
                      controls
                      className="w-full h-40 object-cover rounded-lg"
                      src={URL.createObjectURL(selectedFile)}
                    >
                      Your browser does not support the video tag.
                    </video>
                  </div>
                )}

                {headerType === "document" && selectedFile && (
                  <div className="mb-2 p-3 bg-gray-100 rounded-lg flex items-center space-x-2">
                    <FaFilePdf className="w-6 h-6 text-red-500" />
                    <div>
                      <div className="text-sm font-medium">
                        {selectedFile.name}
                      </div>
                      <div className="text-xs text-gray-500">
                        {(selectedFile.size / 1024).toFixed(1)} KB
                      </div>
                    </div>
                  </div>
                )}

                {/* Body Section */}
                {bodyText && (
                  <div
                    className="mb-2 whitespace-pre-wrap break-words text-sm leading-relaxed"
                    dangerouslySetInnerHTML={{
                      __html: renderFormattedText(bodyText),
                    }}
                  />
                )}

                {/* Footer Section */}
                {FooterText && (
                  <div className="text-gray-500 border-t pt-2 mt-3 text-xs flex justify-center">
                    {FooterText}
                  </div>
                )}

                {/* Buttons Section */}
                {rows.filter((row) => row.buttonText.trim()).length > 0 && (
                  <div className="mt-3 space-y-2">
                    {rows
                      .filter((row) => row.buttonText.trim())
                      .map((button, index) => (
                        <p
                          key={index}
                          className="font-serif text-blue-400 flex justify-center"
                          style={{ fontSize: "14px" }}
                        >
                          {button.buttonText}
                          <div className="border-t mt-2"></div>
                        </p>
                      ))}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      <div className="flex justify-end space-x-3 -mt-8 mr-0 h-[40px]">
        <Dialog>
          <DialogTrigger asChild>
            <Button
              variant={"outline"}
              className="w-[80px] border-red-500 text-red-500 hover:bg-red-500 hover:text-white mt-0"
              disabled={isViewMode || isUpdateMode}
            >
              Discard
            </Button>
          </DialogTrigger>

          <DialogContent className="sm:max-w-[425px]">
            <DialogHeader>
              <DialogDescription>
                Are you sure you want to discard this Template?
              </DialogDescription>
            </DialogHeader>

            <DialogFooter>
              <DialogClose asChild>
                <Button type="button" variant="outline" className="w-24">
                  Cancel
                </Button>
              </DialogClose>
              <Button
                className="w-24"
                onClick={() => {
                  resetWhatsappContent();
                  onClose();
                }}
                autoFocus
              >
                OK
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
        <Button
          className="w-[100px] bg-[#3A85F7] text-white hover:bg-blue-600 mt-0"
          onClick={() => {
            setIsWhatsappContentSubmitAttempted(true);
            handleSubmitWhatsApp();
          }}
          disabled={isViewMode}
        >
          Save
        </Button>
      </div>
    </>
  );
};

export default CreateContentWhatsapp;